import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { NAV_LINKS, ROUTES, CITY_LINKS } from "@/data/site";
import { useServices, usePackages, useBlogs } from "@/hooks/usePublicData";

function Group({ title, links }) {
  return (
    <div>
      <h2 className="font-heading font-bold text-navy-heading text-lg mb-3">{title}</h2>
      <ul className="space-y-2">
        {links.map(([label, to]) => (
          <li key={to}><Link to={to} className="text-slate-600 hover:text-brand text-sm">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}

export default function SitemapPage() {
  const { data: services = [] } = useServices();
  const { data: packages = [] } = usePackages();
  const { data: blogs = [] } = useBlogs();
  return (
    <>
      <Seo title="Sitemap | Chouhan Taxi Service" description="Browse all pages of the Chouhan Taxi Service website — services, cities, routes, tour packages and travel guides." path="/sitemap" />
      <Breadcrumbs items={[{ label: "Sitemap" }]} />
      <section className="section-pad pt-8">
        <div className="container-x">
          <h1 className="text-3xl sm:text-4xl font-heading font-extrabold text-navy-heading mb-10">Sitemap</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <Group title="Main Pages" links={[...NAV_LINKS.filter(n => !CITY_LINKS.some(c => `/${c.slug}-taxi` === n.to)).map(n => [n.name, n.to]), ["Book a Taxi", "/book-taxi"], ["Blog", "/blog"], ["Privacy Policy", "/privacy-policy"], ["Terms & Conditions", "/terms-conditions"]]} />
            <Group title="City Taxi Pages" links={CITY_LINKS.map(c => [`Taxi in ${c.name}`, `/${c.slug}-taxi`])} />
            <Group title="Taxi Services" links={services.map(s => [s.title, `/taxi-services/${s.slug}`])} />
            <div className="space-y-10">
              <Group title="Popular Routes" links={ROUTES.map(r => [`${r.from} to ${r.to}`, `/routes/${r.slug}`])} />
            </div>
            <Group title="Tour Packages" links={packages.map(p => [p.title, `/tour-packages/${p.slug}`])} />
            <Group title="Travel Guides" links={blogs.map(b => [b.title, `/blog/${b.slug}`])} />
          </div>
        </div>
      </section>
    </>
  );
}
